import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { RunningHistoryType } from '../../store/runningHistoryStore';
import { trackOnboardingCollectedRunningHistory } from '../../utils/analytics';

export type RunningHistoryOptionType = {
  title: string;
  value: RunningHistoryType;
};

const CollectRunningHistory = observer(() => {
  const { runningHistoryStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedRunningHistory(
      runningHistoryStore.selectedRunningHistory,
    );
    navigate(getNextPagePath('CollectRunningHistory'));
  };

  const handleClick = (selectedRunningHistory: RunningHistoryType) => {
    runningHistoryStore.setRunningHistory(selectedRunningHistory);
  };

  const runningHistoryOptions: RunningHistoryOptionType[] = [
    { title: "I wouldn't say so", value: 'nonRunner' },
    { title: 'Yes, but a long time ago', value: 'longTimeAgo' },
    { title: 'Yes, in the past couple of years', value: 'pastCoupleYears' },
    { title: 'Yes, I actively run', value: 'activeRunner' },
  ];

  return (
    <Container>
      <ProgressBar currentPage="CollectRunningHistory" />
      <PageHeader title="Have you been a runner before?"></PageHeader>
      <Flex direction={'column'}>
        {runningHistoryOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            onClick={() => handleClick(option.value)}
            isSelected={
              runningHistoryStore.selectedRunningHistory === option.value
            }
          ></RegularButton>
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={!runningHistoryStore.selectedRunningHistory}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectRunningHistory;
